export const educationData = [
    {
        id: 1,
        institution: 'National Institute of Technology Delhi',
        course: 'B.Tech in Computer Science and Engineering [CGPA 8.84]',
        startYear: '2021',
        endYear: '2025'
    },
    {
        id: 2,
        institution: 'Little Angels High School',
        course: 'CBSE Class 12 [98.4%]',
        startYear: '2020',
        endYear: '2021'
    },
    {
        id: 2,
        institution: 'Little Angels High School',
        course: 'CBSE Class 10 [96.6%]',
        startYear: '2018',
        endYear: '2019'
    },
]